import { useMemo } from 'react'
import { checkFeatureFlagUserGroup, USERS } from 'utils/featureFlagUserGroups'
import { useAuth } from './UseAuth'

export const useFeatureFlagUserGroup = (userGroups = [USERS.withAlmanacEmailAndBetaTesters]) => {
  const email = useAuth()?.email

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => checkFeatureFlagUserGroup(userGroups, email), [email, ...userGroups])
}
